const role = ""

export const setRole = (player) => {
    return {type: 'SET_PLAYER', data: player}
}

export const clear = () => {
    return {type: 'CLEAR_PLAYER'}
}

const reducer = (state = role, action) => {
    switch (action.type) {
        case 'SET_PLAYER':
            return action.data
        case 'CLEAR_PLAYER':
            const role = ""
            return role
        default: return state    
    }
}

export default reducer